module.exports = __webpack_public_path__ + "img/login-art-6.f1083a3.jpg";